import { render, staticRenderFns } from "./InviteFriends.vue?vue&type=template&id=4d4425e0&"
import script from "./InviteFriends.vue?vue&type=script&lang=js&"
export * from "./InviteFriends.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriends.vue?vue&type=style&index=0&id=4d4425e0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports